import PageHeader from "@/components/PageHeader";
import Trust1949 from "@/components/Trust1949";

export default function TraditionPage() {
  return (
    <>
      <PageHeader
        overline="Fondata nel 1949"
        title="Tradition."
        accent="La nostra storia."
        subtitle="Mehr als 75 Jahre Vespa-Kultur unter einem Dach. Zwei Generationen, ein Versprechen — jedes Detail mit der gleichen Hingabe."
      />
      <Trust1949 />
    </>
  );
}
